import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PrivateEventBooking } from '../../../../../../../../../models/scheduled-event';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-private-event-select-payment-amount',
  templateUrl: './private-event-select-payment-amount.component.html',
  styleUrls: ['./private-event-select-payment-amount.component.css']
})
export class PrivateEventSelectPaymentAmountComponent {

  @Input() booking: PrivateEventBooking;
  @Input() submitCallback: (amount?: number) => undefined;

  public partialSelected = false;

  public amount: number;

  public loading = false;

  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService
  ) {}

  public handlePayFullBalance() {
    this.loading = true;
    this.submitCallback();
    this.activeModal.close();
  }

  public handleSelectPartialPayment() {
    this.errorMessage = '';
    this.partialSelected = true;
  }

  public handleBack() {
    this.amount = undefined;
    this.errorMessage = '';
    this.partialSelected = false;
  }

  public onSubmit() {
    this.errorMessage = '';

    if (!this.amount) {
      this.errorMessage = 'Select a payment amount.';
      return;
    }
    if (this.amount <= 0) {
      this.errorMessage = 'The payment amount must be a positive number.';
      return;
    }
    if (this.amount > parseFloat(this.booking.amount_due)) {
      this.errorMessage = 'The payment amount must no greater than ' + this.orgConfig.getCurrencySymbol() + this.booking.amount_due + '.';
      return;
    }

    this.loading = true;

    this.submitCallback(this.amount);
    this.activeModal.close();
  }

}
